export default class SummernoteHelper { 
 
  get defaultEditorOptions(){
    let toolbar = this.defaultToolbar

    let result = {  
      lineNumbers: true,
      toolbar: toolbar, 
      buttons: {}
    }

    return result;
  }

  get defaultToolbar() {
    return ([
      ['fontname', ['fontname']],
      ['font', ['bold', 'underline', 'clear']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['table', ['table']],
      ['insert', ['link', 'media', 'video']],
      ['view', ['fullscreen', 'codeview', 'help']]
    ]);
  }

} 
